import type { FieldOption } from '../constants/field-options-registry.constant';

import { VariableMappingType } from '../enums/mapping-editor.const';

export const inferMappingTypeFromStoredValueAndOptions = (
  storedValue: string,
  fieldOptions: FieldOption[],
): null | VariableMappingType => {
  if (fieldOptions.length === 0) return null;
  const trimmed = storedValue.trim();
  if (trimmed === '') return null;
  const matchesSystemOption = fieldOptions.some((o) => o.value === storedValue);
  if (!matchesSystemOption) {
    return VariableMappingType.CUSTOM;
  }
  return null;
};
